import React, { Component, useState, useEffect } from 'react';
import EditIcon from '@mui/icons-material/Edit';
import Page from '../../components/Page';
import { connect } from 'react-redux';
import {
	TextField,
	Stack,
	Paper,
	Button,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	ButtonGroup,
	Typography,
	Alert,
	CircularProgress,
	Modal,
	Checkbox,
	Pagination,
	InputAdornment,
	Switch,
	FormControlLabel,
} from '@mui/material';
import { Formik } from 'formik';
import _ from 'lodash';
import { load_product } from '../../actions/product.actions';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import SearchIcon from '@mui/icons-material/Search';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import SaveIcon from '@mui/icons-material/Save';
import ReplayIcon from '@mui/icons-material/Replay';
import DoneIcon from '@mui/icons-material/Done';
import { NavLink } from 'react-router-dom';
import CodeIcon from '@mui/icons-material/Code';
import RefreshIcon from '@mui/icons-material/Refresh';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import RemoveIcon from '@mui/icons-material/Remove';
import SyncIcon from '@mui/icons-material/Sync';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import PropTypes from 'prop-types';
import * as GA from '../../util/GA';
import ClearIcon from '@mui/icons-material/Clear';
import { post } from '../../util/api';
import * as XLSX from 'xlsx';

/* const Item = styled(Paper)(({ theme }) => ({
	backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fafafa',
	...theme.typography.body2,
	padding: theme.spacing(1),
	textAlign: 'center',
	color: theme.palette.text.secondary,
})); */

const style = {
	position: 'absolute',
	top: '50%',
	left: '50%',
	transform: 'translate(-50%, -50%)',
	width: 400,
	bgcolor: 'background.paper',
	boxShadow: 24,
	p: 4,
	textAlign: 'center',
};
function TabPanel(props) {
	const { children, value, index, ...other } = props;

	return (
		<div role="tabpanel" hidden={value !== index} id={`simple-tabpanel-${index}`} aria-labelledby={`simple-tab-${index}`} {...other}>
			{value === index && (
				<Box sx={{ p: 3 }}>
					<Typography>{children}</Typography>
				</Box>
			)}
		</div>
	);
}

TabPanel.propTypes = {
	children: PropTypes.node,
	index: PropTypes.number.isRequired,
	value: PropTypes.number.isRequired,
};

function a11yProps(index) {
	return {
		id: `simple-tab-${index}`,
		'aria-controls': `simple-tabpanel-${index}`,
	};
}

function customizer(objValue, srcValue) {
	return _.isUndefined(objValue) || objValue === null ? srcValue : objValue;
}

function PhoneLineWebhook(props) {
	let { data = {}, pid, token, showStaticIp } = props;
	const [webhook, setWebhook] = useState((data.data && data.data.webhook) || '');
	const [tempWebhook, setTempWebhook] = useState('');
	const [isEditing, setIsEditing] = useState(false);
	const [saving, setSaving] = useState(false);
	const [error, setError] = useState(false);
	const [useStaticIp, setUseStaticIp] = useState(!!(data.data && data.data.use_static_ip));
	const [staticIpSaving, setStaticIpSaving] = useState(false);
	const [copiedIp, setCopiedIp] = useState(false);

	useEffect(() => {
		if (!showStaticIp) return;
		fetch(`https://api.maytapi.com/api/${pid}/${data.id}/useStaticIp`, {
			headers: { 'x-maytapi-key': token },
		})
			.then((it) => it.json())
			.then((result) => {
				if (result && result.success) setUseStaticIp(!!(result.config && result.config.use_static_ip));
			})
			.catch((error) => console.error('Error fetching phone static IP setting:', error));
	}, []);

	const onCopyIp = () => {
		setCopiedIp(true);
		setTimeout(() => {
			setCopiedIp(false);
		}, 2000);
	};

	const handleStaticIpToggle = async (checked) => {
		let previous = useStaticIp;
		setUseStaticIp(checked);
		setStaticIpSaving(true);
		try {
			let response = await fetch(`https://api.maytapi.com/api/${pid}/${data.id}/useStaticIp`, {
				method: 'POST',
				headers: {
					accept: 'application/json',
					'Content-Type': 'application/json',
					'x-maytapi-key': token,
				},
				body: JSON.stringify({ use_static_ip: checked }),
			});
			let result = await response.json();
			if (!response.ok || !result.success) throw new Error('Failed to update static IP setting');
			setUseStaticIp(!!(result.config && result.config.use_static_ip));
		} catch (err) {
			console.error('Error updating phone static IP setting:', err);
			setUseStaticIp(previous);
		} finally {
			setStaticIpSaving(false);
		}
	};

	const startEdit = () => {
		setTempWebhook(webhook);
		setIsEditing(true);
		setError(false);
	};

	const cancelEdit = () => {
		setIsEditing(false);
		setError(false);
	};

	const saveWebhook = async () => {
		setSaving(true);
		setError(false);
		try {
			let response = await fetch(`https://api.maytapi.com/api/${pid}/${data.id}/config`, {
				method: 'POST',
				headers: {
					accept: 'application/json',
					'Content-Type': 'application/json',
					'x-maytapi-key': token,
				},
				body: JSON.stringify({ webhook: tempWebhook.trim() }),
			});
			let result = await response.json();
			if (!response.ok || !result.success) throw new Error('Failed to update webhook');
			setWebhook(tempWebhook.trim());
			setIsEditing(false);
		} catch (err) {
			console.error('Error updating phone webhook:', err);
			setError(true);
		} finally {
			setSaving(false);
		}
	};

	return (
		<TableRow>
			<TableCell>{data.id}</TableCell>
			<TableCell>{data.number || 'null'}</TableCell>
			<TableCell sx={{ wordBreak: 'break-all' }}>
				{isEditing ? (
					<TextField
						size="small"
						fullWidth
						value={tempWebhook}
						onChange={(e) => setTempWebhook(e.target.value)}
						placeholder="https://your-webhook-url.com/"
						error={error}
						helperText={error ? 'Failed to update webhook' : ''}
						disabled={saving}
					/>
				) : (
					webhook || 'null'
				)}
			</TableCell>
			<TableCell>
				{isEditing ? (
					<ButtonGroup size="small">
						<Button variant="contained" onClick={saveWebhook} disabled={saving} endIcon={saving ? <CircularProgress size={14} /> : <SaveIcon />}>
							Save
						</Button>
						<Button variant="outlined" onClick={cancelEdit} disabled={saving}>
							Cancel
						</Button>
					</ButtonGroup>
				) : (
					<Button size="small" variant="outlined" onClick={startEdit} endIcon={<EditIcon />}>
						Edit
					</Button>
				)}
			</TableCell>
			{showStaticIp && (
				<TableCell>
					<div style={{ display: 'flex', alignItems: 'center' }}>
						<Switch checked={useStaticIp} disabled={staticIpSaving} onChange={(event) => handleStaticIpToggle(event.target.checked)} />
						{staticIpSaving && <CircularProgress size={16} />}
						{useStaticIp && !staticIpSaving && (
							<CopyToClipboard text={STATIC_WEBHOOK_IP} onCopy={onCopyIp}>
								<Button
									size="small"
									sx={{ textTransform: 'none', fontFamily: 'monospace' }}
									endIcon={copiedIp ? <DoneIcon /> : <ContentCopyIcon />}
								>
									{STATIC_WEBHOOK_IP}
								</Button>
							</CopyToClipboard>
						)}
					</div>
				</TableCell>
			)}
		</TableRow>
	);
}

var defaults = _.partialRight(_.assignWith, customizer);

const STATIC_WEBHOOK_IP = '46.224.46.227';

class Webhook extends Component {
	state = {
		copiedPid: false,
		copiedToken: false,
		saved: 'Save',
		saveColor: '#007fff',
		saveIcon: 'save',
		setDefault: 'Default',
		setDefaultIcon: <ReplayIcon />,
		error: '',
		success: '',
		value: 0,
		use_static_ip: false,
		staticIpSaving: false,
		copiedIp: false,
		btnLoading: false,
		alertbtn: false,
		selected_id: null,
		testwebhookresult: false,
		previousQueues: null,
		isRefreshing: false,
		refreshInterval: null,
		allSelected: false,
		redeployInProgress: false,
		queueRefreshInterval: null,
		processingRefreshInterval: null,
		redeployIds: [],
		processingQueue: {},
		previousProcessingQueue: {},
		currentPage: 1,
		itemsPerPage: 50,
		searchTerm: '',
		csvFile: null,
		csvPhoneIds: [],
		csvInvalidIds: [],
		csvAnalyzing: false,
		bulkClearInProgress: false,
		bulkClearResults: [],
		showCsvResults: false,
		dragActive: false,
	};
	handleChange = (e, { name, value }) => this.setState({ [name]: value });
	handleChangeTab = (event, newValue) => this.setState({ value: newValue });

	handlePageChange = (event, value) => {
		this.setState({ currentPage: value });
	};

	handleSearchChange = (event) => {
		this.setState({ searchTerm: event.target.value, currentPage: 1 });
	};

	handleCsvUpload = (event) => {
		const file = event.target.files[0];
		if (
			file &&
			(file.type === 'text/csv' ||
				file.type === 'text/plain' ||
				file.name.endsWith('.csv') ||
				file.name.endsWith('.txt') ||
				file.name.endsWith('.xlsx') ||
				file.name.endsWith('.xls') ||
				file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
				file.type === 'application/vnd.ms-excel')
		) {
			this.setState({ csvFile: file, csvPhoneIds: [], csvInvalidIds: [], bulkClearResults: [], showCsvResults: false });
			this.analyzeCsv(file);
		}
	};

	handleDragOver = (event) => {
		event.preventDefault();
		event.stopPropagation();
		this.setState({ dragActive: true });
	};

	handleDragLeave = (event) => {
		event.preventDefault();
		event.stopPropagation();
		this.setState({ dragActive: false });
	};

	handleDrop = (event) => {
		event.preventDefault();
		event.stopPropagation();
		this.setState({ dragActive: false });

		const file = event.dataTransfer.files[0];
		if (
			file &&
			(file.type === 'text/csv' ||
				file.type === 'text/plain' ||
				file.name.endsWith('.csv') ||
				file.name.endsWith('.txt') ||
				file.name.endsWith('.xlsx') ||
				file.name.endsWith('.xls') ||
				file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
				file.type === 'application/vnd.ms-excel')
		) {
			this.setState({ csvFile: file, csvPhoneIds: [], csvInvalidIds: [], bulkClearResults: [], showCsvResults: false });
			this.analyzeCsv(file);
		}
	};

	handleUploadClick = (event) => {
		event.preventDefault();
		document.getElementById('csv-file-upload').click();
	};

	analyzeCsv = (file) => {
		this.setState({ csvAnalyzing: true });

		const reader = new FileReader();

		const isExcelFile =
			file.name.endsWith('.xlsx') ||
			file.name.endsWith('.xls') ||
			file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
			file.type === 'application/vnd.ms-excel';

		reader.onload = (e) => {
			try {
				let phoneIds = [];
				let invalidIds = [];
				const validPhoneIds = (this.state.phones || []).map((phone) => phone.id.toString());

				if (isExcelFile) {
					const data = new Uint8Array(e.target.result);
					const workbook = XLSX.read(data, { type: 'array' });
					const firstSheetName = workbook.SheetNames[0];
					const worksheet = workbook.Sheets[firstSheetName];
					const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1, defval: '' });

					jsonData.forEach((row, index) => {
						if (row && row[0] !== undefined && row[0] !== '') {
							const phoneId = row[0].toString().trim();

							if (phoneId && phoneId !== '' && !isNaN(phoneId)) {
								if (validPhoneIds.includes(phoneId)) {
									phoneIds.push(phoneId);
								} else {
									invalidIds.push(phoneId);
								}
							} else if (
								phoneId &&
								phoneId !== '' &&
								phoneId.toLowerCase() !== 'phone id' &&
								phoneId.toLowerCase() !== 'phoneid' &&
								phoneId.toLowerCase() !== 'id'
							) {
								invalidIds.push(phoneId);
							}
						}
					});
				} else {
					const csv = e.target.result.trim();
					const lines = csv.split('\n').filter((line) => line.trim() !== '');

					for (let i = 0; i < lines.length; i++) {
						const line = lines[i].trim();
						if (line) {
							const phoneId = line.includes(',') ? line.split(',')[0].trim() : line.trim();

							if (phoneId && phoneId !== '' && !isNaN(phoneId)) {
								if (validPhoneIds.includes(phoneId)) {
									phoneIds.push(phoneId);
								} else {
									invalidIds.push(phoneId);
								}
							} else if (phoneId && phoneId !== '' && phoneId.toLowerCase() !== 'phone id' && phoneId.toLowerCase() !== 'phoneid') {
								invalidIds.push(phoneId);
							}
						}
					}
				}

				this.setState({
					csvPhoneIds: phoneIds,
					csvInvalidIds: invalidIds,
					csvAnalyzing: false,
					showCsvResults: true,
				});
			} catch (error) {
				console.error('File parsing error:', error);
				this.setState({
					csvAnalyzing: false,
					showCsvResults: true,
					csvPhoneIds: [],
					csvInvalidIds: [],
				});
				alert('Error parsing file. Please check file format and try again.');
			}
		};

		if (isExcelFile) {
			reader.readAsArrayBuffer(file);
		} else {
			reader.readAsText(file);
		}
	};

	handleBulkClear = async () => {
		const { csvPhoneIds, wapiData } = this.state;
		const { pid } = wapiData;

		if (!csvPhoneIds.length) return;

		this.setState({ bulkClearInProgress: true, bulkClearResults: [] });

		for (let i = 0; i < csvPhoneIds.length; i++) {
			const phoneId = csvPhoneIds[i];

			try {
				const uri = `https://api.maytapi.com/api/${pid}/${phoneId}/purgeQueue`;
				const response = await fetch(uri, {
					method: 'GET',
					headers: {
						accept: 'application/json',
						'Content-Type': 'application/json',
						'x-maytapi-key': this.props.product.settings.wapi_token,
					},
				});

				const responseData = await response.json();

				const result = {
					phoneId,
					success: responseData.success === true,
					message: responseData.success === true ? 'Successfully Cleared' : `Error: ${responseData.message || response.status}`,
				};

				this.setState((prevState) => ({
					bulkClearResults: [...prevState.bulkClearResults, result],
				}));
			} catch (error) {
				const result = {
					phoneId,
					success: false,
					message: `Error: ${error.message}`,
				};

				this.setState((prevState) => ({
					bulkClearResults: [...prevState.bulkClearResults, result],
				}));
			}

			if (i < csvPhoneIds.length - 1) {
				await new Promise((resolve) => setTimeout(resolve, 3000));
			}
		}

		this.setState({ bulkClearInProgress: false });
	};

	clearCsvData = () => {
		const fileInput = document.getElementById('csv-file-upload');
		if (fileInput) {
			fileInput.value = '';
		}

		this.setState({
			csvFile: null,
			csvPhoneIds: [],
			csvInvalidIds: [],
			bulkClearResults: [],
			showCsvResults: false,
		});
	};

	ClearQueue = async () => {
		let { wapiData, selected_id } = this.state;
		let { pid } = wapiData;

		//this.setState({ btnLoading: true, alertbtn: true, selected_id: id });

		let uri = `https://api.maytapi.com/api/${pid}/${selected_id}/purgeQueue`;
		let response = fetch(uri, {
			method: 'GET',
			headers: {
				accept: 'application/json',
				'Content-Type': 'application/json',
				'x-maytapi-key': this.props.product.settings.wapi_token,
			},
		})
			.then((data) => {
				console.log('data ', data);
				if (data && data.status == 200) {
					this.setState({ btnLoading: false, alertbtn: false, selected_id: null, messageAlert: true, message: 'Successfully Cleared' });
				} else {
					this.setState({ btnLoading: false, alertbtn: false, selected_id: null, message: 'Undefined', messageAlert: true });
				}
			})
			.catch((error) => {
				this.setState({ btnLoading: false, alertbtn: false, selected_id: null, message: error.message, messageAlert: true });
			});
	};

	handleSubmit = (values) => {
		let stable_webhook = values.webhook;
		if (this.state && this.state.webhook_last) stable_webhook = this.state.webhook_last;

		let isDefault = !!values.default;
		let uri = `https://api.maytapi.com/api/${this.props.product.id}/setWebhook`;
		let response = fetch(uri, {
			method: 'POST',
			headers: {
				accept: 'application/json',
				'Content-Type': 'application/json',
				'x-maytapi-key': this.props.product.settings.wapi_token,
			},
			body: JSON.stringify({
				webhook: isDefault ? 'https://api.maytapi.com/webhook/live/send/' + values.default : stable_webhook,
			}),
		})
			.then((data) => {
				isDefault
					? this.setState({ setDefault: 'Success', setDefaultIcon: <DoneIcon /> })
					: this.setState({ saved: 'Saved', saveColor: 'teal', saveIcon: 'check' });

				if (!_.startsWith(stable_webhook, 'https://api.maytapi.com/')) {
					GA.event({ action: 'set-webhook', category: 'analyze', label: 'Changed the webhook', value: true });
				}
				console.log('Success:', data);
			})
			.catch((error) => {
				this.setState({ saved: 'Error', saveColor: 'red', saveIcon: 'x' });
				console.error('Error:', error);
			});
		clearTimeout(this.timeout);
		this.timeout = setTimeout(() => {
			this.setState({ saved: 'Save', saveColor: 'blue', saveIcon: 'save', setDefaultIcon: <ReplayIcon />, setDefault: 'Default' });
			this.refresh();
		}, 2000);
		return response;
	};
	onCopyPid = () => {
		if (!this.state.copiedPid) this.setState({ copiedPid: true });
		clearTimeout(this.timeout);
		this.timeout = setTimeout(() => {
			this.setState({ copiedPid: false });
		}, 2000);
	};
	onCopyIp = () => {
		this.setState({ copiedIp: true });
		setTimeout(() => {
			this.setState({ copiedIp: false });
		}, 2000);
	};
	handleStaticIpToggle = async (checked) => {
		let previous = this.state.use_static_ip;
		this.setState({ use_static_ip: checked, staticIpSaving: true });
		try {
			let uri = `https://api.maytapi.com/api/${this.props.product.id}/useStaticIp`;
			let response = await fetch(uri, {
				method: 'POST',
				headers: {
					accept: 'application/json',
					'Content-Type': 'application/json',
					'x-maytapi-key': this.props.product.settings.wapi_token,
				},
				body: JSON.stringify({ use_static_ip: checked }),
			});
			let result = await response.json();
			if (!response.ok || !result.success) throw new Error('Failed to update static IP setting');
			this.setState({ use_static_ip: !!(result.config && result.config.use_static_ip), staticIpSaving: false });
		} catch (error) {
			console.error('Error:', error);
			this.setState({ use_static_ip: previous, staticIpSaving: false });
		}
	};
	refresh() {
		setTimeout(() => {
			this.props.dispatch(load_product('maytapi'));
		}, 1000);
	}
	handleClose = () => {
		this.setState({ alertbtn: false, goToSubs: false, open: false, messageAlert: false });
	};
	closeDeleteButton = () => {
		this.setState({ alertbtn: false, goToSubs: false, open: false, messageAlert: false });
	};

	fetchSendingStats = async (id, queueCount) => {
		if (queueCount === 0) {
			this.updateProcessingQueue(id, 0);
			return;
		}

		const uri = `https://api.maytapi.com/api/${this.props.product.id}/${id}/queue?token=${this.props.product.settings.wapi_token}`;
		try {
			const response = await fetch(uri, { headers: { 'Content-Type': 'application/json' }, method: 'get' });
			const data = await response.json();
			if (data.success) {
				this.updateProcessingQueue(id, data.stats.sending);
			}
		} catch (error) {
			console.error(`Error fetching sending stats for id ${id}:`, error);
		}
	};

	updateProcessingQueue = (id, currentProcessing) => {
		this.setState((prevState) => ({
			previousProcessingQueue: {
				...prevState.previousProcessingQueue,
				[id]: prevState.processingQueue[id] || 0,
			},
			processingQueue: {
				...prevState.processingQueue,
				[id]: currentProcessing,
			},
		}));
	};

	updateProcessingStats = async () => {
		const { queues } = this.state;
		if (!queues || !queues.queues) return;

		const processingStatsPromises = queues.queues.filter((queue) => queue.queue > 0).map((queue) => this.fetchSendingStats(queue.id, queue.queue));

		await Promise.all(processingStatsPromises);
	};

	updateQueueAndSendingStats = async () => {
		if (this.state.isRefreshing) return;

		this.setState({ isRefreshing: true });

		let queueuri = `https://api.maytapi.com/api/${this.props.product.id}/queues?token=${this.props.product.settings.wapi_token}&number=true`;

		try {
			let queues = await fetch(queueuri, { headers: { 'Content-Type': 'application/json' }, method: 'get' }).then((it) => it.json());

			this.setState((prevState) => ({
				queues,
				previousQueues: prevState.queues,
			}));

			await this.updateProcessingStats();
		} catch (error) {
			console.error('Error updating queue data:', error);
		} finally {
			this.setState({ isRefreshing: false });
		}
	};

	handleRefreshClick = () => {
		if (!this.state.isRefreshing) {
			this.updateQueueAndSendingStats();
			this.resetAndStartRefreshInterval();
		}
	};

	getProcessingChangeIcon = (id) => {
		const currentProcessing = this.state.processingQueue[id] || 0;
		const previousProcessing = this.state.previousProcessingQueue[id];

		if (currentProcessing === 0 || previousProcessing === undefined) return null;
		if (currentProcessing > previousProcessing) {
			return <ArrowUpwardIcon style={{ color: 'red' }} />;
		} else if (currentProcessing < previousProcessing) {
			return <ArrowDownwardIcon style={{ color: 'blue' }} />;
		} else {
			return <RemoveIcon style={{ color: 'gray' }} />;
		}
	};

	handleSelectAll = () => {
		this.setState((prevState) => {
			const filteredQueues = this.filterQueues(prevState.queues.queues || []);
			if (prevState.allSelected) {
				return { redeployIds: [], allSelected: false };
			} else {
				const allFilteredIds = filteredQueues.map((queue) => queue.id);
				return { redeployIds: allFilteredIds, allSelected: true };
			}
		});
	};

	handleCheckboxChange = (id) => {
		this.setState((prevState) => {
			const newRedeployIds = prevState.redeployIds.includes(id) ? prevState.redeployIds.filter((item) => item !== id) : [...prevState.redeployIds, id];

			const allSelected = newRedeployIds.length === this.state.queues.queues.length;

			return { redeployIds: newRedeployIds, allSelected };
		});
	};

	handleRedeploy = async () => {
		const { redeployIds } = this.state;
		if (redeployIds.length === 0) return;

		this.setState({ redeployInProgress: true });

		for (const id of redeployIds) {
			try {
				const response = await fetch(`https://api.maytapi.com/api/${this.props.product.id}/${id}/redeploy`, {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
						'x-maytapi-key': this.props.product.settings.wapi_token,
					},
				});
			} catch (error) {
				console.error(`Error redeploying phone ${id}:`, error);
			}
		}

		this.setState({
			redeployInProgress: false,
			redeployIds: [],
			allSelected: false,
		});

		this.updateQueueAndSendingStats();
	};

	checkWebhook = async (webhook) => {
		let phones = this.state.phones;
		let filtered_phones = _.filter(phones, (it) => it.status !== 'disabled');
		let selected_phone = (filtered_phones && filtered_phones[0] && filtered_phones[0].id) || (phones && phones[0] && phones[0].id);
		let product = this.props.product;
		let body = {
			type: 'message',
			user: {
				id: '905801234567@c.us',
				name: 'Test Number',
				phone: '905801234567',
			},
			message: {
				id: 'false_905801234567@c.us_2E44F8B915B6192020A4A4716A7B68EF',
				text: 'Test',
				type: 'text',
				fromMe: false,
				_serialized: 'false_905801234567@c.us_2E44F8B915B6192020A4A4716A7B68EF',
			},
			phoneId: selected_phone,
			phone_id: selected_phone,
			receiver: '79655865528',
			productId: product.id,
			timestamp: Math.floor(Date.now() / 1000),
			product_id: product.id,
			conversation: '905801234567@c.us',
			conversation_name: 'Test Number',
		};
		if (webhook) {
			try {
				post('/maytapi/live/checkWebhook', { webhook, body }).then((response) => {
					if (response && response.data && response.data.success === true) {
						this.setState({ success: 'Worked successfly. Please set the webhook like that!', testwebhookresult: true, error: null });
					} else {
						this.setState({
							success: null,
							testwebhookresult: true,
							error:
								(response && response.data && response.data.message) ||
								'\t The error message "The URL you entered is not reachable. Please ensure that your URL is correct and your service is up and running" may be displayed after your server attempts to send a request to the specified URL and cannot reach it.\n Example: https://example.com/webhook-endpoint',
						});
					}
				});
			} catch (error) {
				this.setState({
					error:
						error.message +
						'\t The error message "The URL you entered is not reachable. Please ensure that your URL is correct and your service is up and running" may be displayed after your server attempts to send a request to the specified URL and cannot reach it.\n Example: https://example.com/webhook-endpoint',
				});
			}
		} else {
			this.setState({ error: 'Webhook is empty! Please set the webhook.' });
		}
	};

	async componentDidMount() {
		let uri = `https://api.maytapi.com/api/${this.props.product.id}/product?token=${this.props.product.settings.wapi_token}`;
		let phoneuri = `https://api.maytapi.com/api/${this.props.product.id}/listPhones?token=${this.props.product.settings.wapi_token}&config=true`;
		let queueuri = `https://api.maytapi.com/api/${this.props.product.id}/queues?token=${this.props.product.settings.wapi_token}&number=true`;

		try {
			const data = await fetch(uri, { headers: { 'Content-Type': 'application/json' }, method: 'get' }).then((it) => it.json());
			const phones = await fetch(phoneuri, { headers: { 'Content-Type': 'application/json' }, method: 'get' }).then((it) => it.json());
			const queues = await fetch(queueuri, { headers: { 'Content-Type': 'application/json' }, method: 'get' }).then((it) => it.json());

			await this.setState({ wapiData: data, phones, queues, webhook_last: data.webhook });

			fetch(`https://api.maytapi.com/api/${this.props.product.id}/useStaticIp`, {
				headers: { 'x-maytapi-key': this.props.product.settings.wapi_token },
			})
				.then((it) => it.json())
				.then((result) => {
					if (result && result.success) this.setState({ use_static_ip: !!(result.config && result.config.use_static_ip) });
				})
				.catch((error) => console.error('Error fetching static IP setting:', error));

			await this.updateProcessingStats();

			this.resetAndStartRefreshInterval();
		} catch (error) {
			console.error('Error fetching initial data:', error);
		}
	}

	componentWillUnmount() {
		this.resetAndStartRefreshInterval();
	}

	resetAndStartRefreshInterval = () => {
		if (this.state.refreshInterval) {
			clearInterval(this.state.refreshInterval);
		}
		if (this.state.queueRefreshInterval) {
			clearInterval(this.state.queueRefreshInterval);
		}
		if (this.state.processingRefreshInterval) {
			clearInterval(this.state.processingRefreshInterval);
		}

		const refreshInterval = setInterval(this.updateQueueAndSendingStats, 60000);
		const processingRefreshInterval = setInterval(this.updateProcessingStats, 10000);

		this.setState({
			refreshInterval,
			queueRefreshInterval: refreshInterval,
			processingRefreshInterval,
		});
	};

	filterQueues = (queues) => {
		const { searchTerm } = this.state;
		if (!searchTerm) return queues;
		return queues.filter((queue) => queue.id.toString().includes(searchTerm) || (queue.number && queue.number.includes(searchTerm)));
	};

	render() {
		let wapiData = this.state.wapiData;
		let phones = this.state.phones;
		let queues = this.state.queues && this.state.queues.queues;
		const { currentPage, itemsPerPage, searchTerm } = this.state;
		const filteredQueues = this.filterQueues(queues || []);
		const indexOfLastItem = currentPage * itemsPerPage;
		const indexOfFirstItem = indexOfLastItem - itemsPerPage;
		const currentItems = filteredQueues.slice(indexOfFirstItem, indexOfLastItem);
		const pageCount = Math.ceil(filteredQueues.length / itemsPerPage);
		let value = this.state.value;
		const initials = defaults(wapiData);
		let product = this.props.product;
		let isLive = (product.settings && product.settings.subscription_package === 'live') || product.settings.subscription_package === 'maytapi-custom-api';
		let isRocket = wapiData && wapiData.pid === 'd9c31450-5a2b-4eef-a755-6534ce76e8f3';
		let liveToken = product.settings && product.settings.live.token;
		console.log('queues', queues);
		if (!this.state.wapiData || !phones)
			return (
				<Page title="Developers" subtitle="Webhook" icon={<CodeIcon />}>
					<Stack sx={{ marginTop: '20%', marginLeft: '50%' }} attached="bottom">
						<CircularProgress disableShrink />
					</Stack>
				</Page>
			);
		return (
			<Page title="Developers" subtitle="Webhook" icon={<CodeIcon />}>
				<Stack spacing={2}>
					<Formik initialValues={initials} onSubmit={this.handleSubmit}>
						{(props) => {
							const { values, handleChange, handleBlur, handleSubmit } = props;
							return (
								<div style={{ marginTop: 15 }}>
									<TextField
										id="Webhook"
										label="Webhook Url"
										name="webhook"
										type="text"
										margin="normal"
										value={values.webhook}
										placeholder="https://your-webhook-url.com/"
										onChange={(event) => {
											handleChange(event);
											this.setState({ webhook_last: event.target.value, success: null });
										}}
										onBlur={handleBlur}
										action
										fullWidth
										InputProps={{
											endAdornment: (
												<ButtonGroup variant="contained" size="small">
													<CopyToClipboard text={values.webhook} onCopy={this.onCopyPid}>
														<Button
															size="small"
															sx={{
																backgroundColor: this.state.copiedPid ? 'teal' : '#c2c2c2',
																':hover': {
																	backgroundColor: '#afadad',
																},
															}}
															endIcon={this.state.copiedPid ? <DoneIcon /> : <ContentCopyIcon />}
														>
															{this.state.copiedPid ? 'Copied' : 'Copy'}
														</Button>
													</CopyToClipboard>
													<Button
														size="small"
														onClick={() => {
															this.setState({ testwebhook: true, testwebhookresult: false });
															this.checkWebhook(this.state.webhook_last);
														}}
														sx={{
															background: this.state.saveColor,
															':hover': {
																backgroundColor: '#0474e5',
															},
														}}
														endIcon={this.state.saveColor === '#007ff' ? <DoneIcon /> : <SaveIcon />}
													>
														{this.state.saved}
													</Button>
													{product.settings && product.settings.agent_limit && product.settings.agent_limit > 0 ? (
														<Button
															size="small"
															onClick={() => this.handleSubmit({ default: liveToken })}
															sx={{
																background: '#21ba45',
																':hover': {
																	backgroundColor: '#1b9f3a',
																},
															}}
															endIcon={this.state.setDefaultIcon}
														>
															{this.state.setDefault}
														</Button>
													) : (
														<></>
													)}
												</ButtonGroup>
											),
										}}
									></TextField>

									{!isRocket && (
										<>
											<Stack direction="row" alignItems="center" spacing={1}>
												<FormControlLabel
													control={
														<Switch
															checked={this.state.use_static_ip}
															disabled={this.state.staticIpSaving}
															onChange={(event) => this.handleStaticIpToggle(event.target.checked)}
														/>
													}
													label="Receive webhooks from a static IP"
												/>
												{this.state.staticIpSaving && <CircularProgress size={16} />}
											</Stack>
											{this.state.use_static_ip && (
												<Alert severity="info" sx={{ marginBottom: 1 }}>
													{'Your webhooks will be delivered from the static IP address '}
													<b>{STATIC_WEBHOOK_IP}</b>
													{'. Add this IP to your firewall allowlist.'}
													<CopyToClipboard text={STATIC_WEBHOOK_IP} onCopy={this.onCopyIp}>
														<Button
															size="small"
															sx={{ marginLeft: 1 }}
															endIcon={this.state.copiedIp ? <DoneIcon /> : <ContentCopyIcon />}
														>
															{this.state.copiedIp ? 'Copied' : 'Copy IP'}
														</Button>
													</CopyToClipboard>
												</Alert>
											)}
										</>
									)}

									{/* {this.state.error && (
										<Alert severity="error">
											{this.state.error}
											<br />
											{' Look at the '}

											<NavLink to="/developers/documentation">documentation</NavLink>
											{'.'}
										</Alert>
									)} */}
									{this.state.success && <Alert severity="success">{this.state.success}</Alert>}
								</div>
							);
						}}
					</Formik>
					{((initials.webhook && _.includes(initials.webhook, 'ngrok')) ||
						_.includes(initials.webhook, 'free') ||
						_.includes(initials.webhook, 'webhook')) && (
						<Alert severity="warning">
							{
								'Warning: If your webhook is unreachable, it will be automatically deleted by the system. Please consider this when using temporary webhook services (e.g., ngrok, webhook.site).'
							}
						</Alert>
					)}
					{isLive ? (
						<Alert severity="warning">{'Your LiveChat webhook is https://api.maytapi.com/webhook/live/send/' + liveToken}</Alert>
					) : (
						// <Message warning style={{ height: 'auto' }}>
						// 	{'Your LiveChat webhook is https://api.maytapi.com/webhook/live/send/' + liveToken}
						// </Message>
						''
					)}
					<Box sx={{ width: '100%' }}>
						<Box sx={{ marginBottom: 2 }}>
							<Typography variant="body2" color="black" gutterBottom sx={{ display: 'flex', alignItems: 'center' }}>
								<span style={{ marginRight: '8px' }}>•</span> Queue information is automatically refreshed every 60 seconds.
							</Typography>
							<Typography variant="body2" color="black" gutterBottom sx={{ display: 'flex', alignItems: 'center' }}>
								<span style={{ marginRight: '8px' }}>•</span> If you have a queue, Processing information is automatically refreshed every 10
								seconds.
							</Typography>
						</Box>
						<Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
							<Button
								variant="contained"
								onClick={this.handleRefreshClick}
								endIcon={this.state.isRefreshing ? <CircularProgress size={18} /> : <SyncIcon />}
								sx={{ backgroundColor: '#f26304', '&:hover': { backgroundColor: '#b35900' } }}
								disabled={this.state.isRefreshing}
							>
								{this.state.isRefreshing ? 'Refreshing...' : 'Refresh Queue'}
							</Button>
							<Button
								variant="contained"
								onClick={this.handleSelectAll}
								sx={{ marginLeft: '5px', backgroundColor: '#007fff', '&:hover': { backgroundColor: '#006bcc' } }}
								endIcon={<CheckBoxIcon />}
							>
								Select All
							</Button>
							<Button
								variant="contained"
								onClick={this.handleRedeploy}
								disabled={this.state.redeployIds.length === 0 || this.state.redeployInProgress}
								sx={{
									marginLeft: '5px',
									backgroundColor: '#db2828',
									'&:hover': { backgroundColor: '#800000' },
									'@media (max-width: 376px)': { marginTop: '5px' },
								}}
								endIcon={<RefreshIcon />}
							>
								{this.state.redeployInProgress ? 'Redeploying...' : 'Redeploy'}
							</Button>
							<Tabs value={value} onChange={this.handleChangeTab} aria-label="basic tabs example">
								<Tab label="Messages Queue" {...a11yProps(0)} />
								<Tab label="Phones Webhooks" {...a11yProps(1)} />
								{this.state &&
									this.state.wapiData &&
									this.state.wapiData.pid &&
									this.state.wapiData.pid === 'd9c31450-5a2b-4eef-a755-6534ce76e8f3' && <Tab label="Bulk Clear Queue" {...a11yProps(2)} />}
							</Tabs>
						</Box>
						<TabPanel value={value} index={0}>
							<Typography variant="h5" gutterBottom component="div">
								Phones Messages Queue:
							</Typography>
							<TextField
								fullWidth
								variant="outlined"
								placeholder="Search by Phone ID or Number"
								value={searchTerm}
								onChange={this.handleSearchChange}
								sx={{ mb: 2 }}
								InputProps={{
									startAdornment: (
										<InputAdornment position="start">
											<SearchIcon />
										</InputAdornment>
									),
								}}
							/>
							<TableContainer component={Paper}>
								<Table sx={{ background: '#fafafa' }}>
									<TableHead>
										<TableRow>
											<TableCell>Phone ID</TableCell>
											<TableCell>Number</TableCell>
											<TableCell>Status</TableCell>
											<TableCell>Queue</TableCell>
											<TableCell>Processing</TableCell>
											<TableCell>Redeploy</TableCell>
											<TableCell>Clear Queue</TableCell>
										</TableRow>
									</TableHead>

									<TableBody>
										{!currentItems.length ? (
											<TableRow>
												<TableCell style={{ textAlign: 'center' }} colSpan="7">
													No matching results found.
												</TableCell>
											</TableRow>
										) : (
											currentItems.map((data, index) => {
												const currentProcessing = this.state.processingQueue[data.id] || 0;
												const previousProcessing = this.state.previousProcessingQueue[data.id];
												return (
													<TableRow key={data.id}>
														<TableCell>{data.id}</TableCell>
														<TableCell>{data.number || 'null'}</TableCell>
														<TableCell>{data.status || 'no calls'}</TableCell>
														<TableCell>{data.queue !== 0 ? data.queue : 'Empty'}</TableCell>
														<TableCell>
															<div style={{ display: 'flex', alignItems: 'center' }}>
																{this.getProcessingChangeIcon(data.id)}
																<span style={{ marginLeft: currentProcessing !== 0 ? '4px' : '0', fontSize: '0.875rem' }}>
																	{currentProcessing !== 0 ? currentProcessing : ''}
																</span>
															</div>
														</TableCell>
														<TableCell>
															<Checkbox
																checked={this.state.redeployIds.includes(data.id)}
																onChange={() => this.handleCheckboxChange(data.id)}
																inputProps={{ 'aria-label': 'controlled' }}
															/>
														</TableCell>
														<TableCell>
															{data.queue !== 0 && (
																<Button
																	size="small"
																	sx={{
																		backgroundColor: 'white',
																		':hover': {
																			backgroundColor: '#f5f5f5',
																		},
																	}}
																	loading={this.state.btnLoading}
																	disabled={this.state.btnLoading}
																	endIcon={<ClearIcon />}
																	onClick={() => this.setState({ alertbtn: true, selected_id: data.id })}
																>
																	{'Clear'}
																</Button>
															)}
														</TableCell>
													</TableRow>
												);
											})
										)}
									</TableBody>
								</Table>
							</TableContainer>
							<Stack spacing={2} alignItems="center" sx={{ marginTop: 2 }}>
								<Pagination
									count={pageCount}
									page={currentPage}
									onChange={this.handlePageChange}
									color="primary"
									showFirstButton
									showLastButton
								/>
							</Stack>
						</TabPanel>
						<TabPanel value={value} index={1}>
							<Alert severity="info">
								{`If you have more than one phone and want to set phone specific webhook you can use POST "/{phone_id}/config" API.`}
								<p>
									Go to <a href="/developers/documentation">documentation page</a> for more information.
								</p>
							</Alert>
							<Typography variant="h5" gutterBottom component="div">
								Phones Webhooks:
							</Typography>
							<TableContainer component={Paper}>
								<Table sx={{ background: '#fafafa', tableLayout: 'fixed', minWidth: 750 }}>
									<TableHead>
										<TableRow>
											<TableCell sx={{ width: 100 }}>Phone ID</TableCell>
											<TableCell sx={{ width: 130 }}>Number</TableCell>
											<TableCell>Webhook</TableCell>
											<TableCell sx={{ width: 170 }}>Set Webhook</TableCell>
											{!isRocket && <TableCell sx={{ width: 210 }}>Static IP</TableCell>}
										</TableRow>
									</TableHead>

									<TableBody>
										{!phones.length ? (
											<TableRow>
												<TableCell style={{ textAlign: 'center' }} colSpan={isRocket ? 4 : 5}>
													There is no connected phone.
												</TableCell>
											</TableRow>
										) : (
											_.map(phones, (data, index) => (
												<PhoneLineWebhook
													key={index}
													data={data}
													pid={this.props.product.id}
													token={this.props.product.settings.wapi_token}
													showStaticIp={!isRocket}
												/>
											))
										)}
									</TableBody>
								</Table>
							</TableContainer>
						</TabPanel>
						<TabPanel value={value} index={2}>
							<Typography variant="h5" gutterBottom component="div">
								Bulk Clear Queue:
							</Typography>

							<Alert severity="info" sx={{ mb: 2 }}>
								Upload a CSV, TXT, or Excel file where the first column contains Phone IDs. Each phone's queue will be cleared with a 3-second
								interval between requests.
							</Alert>

							<label htmlFor="csv-file-upload">
								<Paper
									sx={{
										p: 3,
										mb: 2,
										border: this.state.dragActive ? '2px solid #1976d2' : '2px dashed #ccc',
										backgroundColor: this.state.dragActive ? '#e3f2fd' : 'inherit',
										textAlign: 'center',
										cursor: this.state.csvAnalyzing || this.state.bulkClearInProgress ? 'not-allowed' : 'pointer',
										opacity: this.state.csvAnalyzing || this.state.bulkClearInProgress ? 0.6 : 1,
										transition: 'all 0.3s ease',
										'&:hover': {
											border: this.state.csvAnalyzing || this.state.bulkClearInProgress ? '2px dashed #ccc' : '2px solid #1976d2',
											backgroundColor: this.state.csvAnalyzing || this.state.bulkClearInProgress ? 'inherit' : '#f5f5f5',
										},
									}}
									onDragOver={this.handleDragOver}
									onDragLeave={this.handleDragLeave}
									onDrop={this.handleDrop}
								>
									<input
										accept=".csv,.txt,.xlsx,.xls"
										style={{ display: 'none' }}
										id="csv-file-upload"
										type="file"
										onChange={this.handleCsvUpload}
									/>

									{this.state.csvAnalyzing ? (
										<Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
											<CircularProgress size={20} sx={{ mr: 1 }} />
											<Typography variant="body2">Analyzing CSV...</Typography>
										</Box>
									) : this.state.csvFile ? (
										<Box>
											<Typography variant="h6" sx={{ mb: 1, color: '#1976d2' }}>
												{this.state.csvFile.name}
											</Typography>
											<Typography variant="body2" color="text.secondary">
												Click to change file or drag & drop a new one
											</Typography>
										</Box>
									) : (
										<Box>
											<Typography variant="h6" sx={{ mb: 1, color: '#666' }}>
												Click to upload or drag & drop CSV file
											</Typography>
											<Typography variant="body2" color="text.secondary">
												Supports .csv, .txt, .xlsx and .xls files
											</Typography>
										</Box>
									)}
								</Paper>
							</label>

							{this.state.showCsvResults && this.state.csvPhoneIds.length > 0 && (
								<Paper sx={{ p: 2, mb: 2 }}>
									<Typography variant="h6" gutterBottom>
										Found {this.state.csvPhoneIds.length} Valid Phone IDs:
									</Typography>

									<Box sx={{ display: 'flex', gap: 3, flexWrap: 'wrap' }}>
										{/* Sol Kısım - Phone ID Listesi */}
										<Box sx={{ flex: '1 1 300px', minWidth: '300px' }}>
											<Box sx={{ maxHeight: 200, overflowY: 'auto', mb: 2 }}>
												{this.state.csvPhoneIds.map((phoneId, index) => (
													<Typography key={index} variant="body2" sx={{ fontFamily: 'monospace', color: 'success.main' }}>
														✓ {index + 1}. {phoneId}
													</Typography>
												))}
											</Box>
										</Box>

										{/* Sağ Kısım - Progress Tracking */}
										<Box sx={{ flex: '1 1 250px', minWidth: '250px' }}>
											{this.state.bulkClearInProgress && (
												<Paper sx={{ p: 2, backgroundColor: '#f5f5f5', textAlign: 'center' }}>
													<Typography variant="h6" gutterBottom sx={{ color: '#1976d2' }}>
														Processing...
													</Typography>

													<CircularProgress size={40} sx={{ mb: 2 }} />

													<Typography variant="h5" sx={{ fontWeight: 'bold', color: '#1976d2' }}>
														{this.state.bulkClearResults.length} / {this.state.csvPhoneIds.length}
													</Typography>

													{this.state.bulkClearResults.length > 0 && (
														<Box sx={{ maxHeight: 150, overflowY: 'auto', mt: 2, textAlign: 'left' }}>
															{this.state.bulkClearResults.slice(-5).map((result, index) => (
																<Typography
																	key={index}
																	variant="body2"
																	sx={{
																		fontFamily: 'monospace',
																		color: result.success ? 'success.main' : 'error.main',
																		mb: 0.5,
																	}}
																>
																	{result.success ? '✓' : '✗'} {result.phoneId}: {result.message}
																</Typography>
															))}
															{this.state.bulkClearResults.length > 5 && (
																<Typography variant="caption" color="text.secondary">
																	Showing last 5 results...
																</Typography>
															)}
														</Box>
													)}
												</Paper>
											)}
										</Box>
									</Box>

									{this.state.csvInvalidIds && this.state.csvInvalidIds.length > 0 && (
										<Box sx={{ mt: 2 }}>
											<Alert severity="warning" sx={{ mb: 2 }}>
												Found {this.state.csvInvalidIds.length} invalid or non-existent Phone IDs that will be skipped:
											</Alert>
											<Box sx={{ maxHeight: 150, overflowY: 'auto', mb: 2 }}>
												{this.state.csvInvalidIds.map((phoneId, index) => (
													<Typography key={index} variant="body2" sx={{ fontFamily: 'monospace', color: 'error.main' }}>
														✗ {phoneId}
													</Typography>
												))}
											</Box>
										</Box>
									)}

									<ButtonGroup sx={{ mt: 2 }}>
										<Button
											variant="contained"
											color="error"
											onClick={this.handleBulkClear}
											disabled={this.state.bulkClearInProgress}
											endIcon={this.state.bulkClearInProgress ? <CircularProgress size={16} /> : <ClearIcon />}
										>
											{this.state.bulkClearInProgress ? 'Clearing...' : `Clear ${this.state.csvPhoneIds.length} Queues`}
										</Button>
										<Button variant="outlined" onClick={this.clearCsvData} disabled={this.state.bulkClearInProgress}>
											Reset
										</Button>
									</ButtonGroup>
								</Paper>
							)}

							{this.state.bulkClearResults.length > 0 && !this.state.bulkClearInProgress && (
								<Paper sx={{ p: 2 }}>
									<Typography variant="h6" gutterBottom>
										Clear Results:
									</Typography>
									<TableContainer sx={{ maxHeight: 300 }}>
										<Table size="small">
											<TableHead>
												<TableRow>
													<TableCell>Phone ID</TableCell>
													<TableCell>Status</TableCell>
													<TableCell>Message</TableCell>
												</TableRow>
											</TableHead>
											<TableBody>
												{this.state.bulkClearResults.map((result, index) => (
													<TableRow key={index}>
														<TableCell sx={{ fontFamily: 'monospace' }}>{result.phoneId}</TableCell>
														<TableCell>
															<Typography variant="body2" color={result.success ? 'success.main' : 'error.main'}>
																{result.success ? 'Success' : 'Failed'}
															</Typography>
														</TableCell>
														<TableCell>{result.message}</TableCell>
													</TableRow>
												))}
											</TableBody>
										</Table>
									</TableContainer>
								</Paper>
							)}

							{this.state.showCsvResults && this.state.csvPhoneIds.length === 0 && (
								<Alert severity="error">
									{this.state.csvInvalidIds && this.state.csvInvalidIds.length > 0
										? `No valid Phone IDs found. All ${this.state.csvInvalidIds.length} IDs are invalid or don't exist in your phone list.`
										: 'No valid Phone IDs found in the first column of the CSV file.'}
								</Alert>
							)}

							{this.state.xlsxError && (
								<Alert severity="error" sx={{ mb: 2 }}>
									{this.state.xlsxError}
								</Alert>
							)}
						</TabPanel>
					</Box>
				</Stack>
				{/* */}
				<Modal
					sx={{ background: '#000000ad' }}
					hideBackdrop
					open={this.state.alertbtn}
					onClose={this.handleClose}
					aria-labelledby="child-modal-title"
					aria-describedby="child-modal-description"
				>
					<Box sx={style}>
						<Typography id="modal-modal-title" variant="h6" component="h2">
							If you clear the queue of the Phone
							<Typography sx={{ color: 'red', display: 'contents' }}> {this.state.selected_id} </Typography>, the expected messages will be
							deleted!
							<Typography id="modal-modal-title" variant="h6" component="h2">
								Are you sure you want to delete the messages in the queue?
							</Typography>
						</Typography>
						<Typography id="modal-modal-description" sx={{ mt: 2 }}>
							<ButtonGroup>
								<Button variant="outlined" onClick={this.closeDeleteButton}>
									No
								</Button>
								<Button variant="outlined" onClick={this.ClearQueue}>
									Yes
								</Button>
							</ButtonGroup>
						</Typography>
					</Box>
				</Modal>
				<Modal
					sx={{ background: '#000000ad' }}
					hideBackdrop
					open={this.state.messageAlert}
					onClose={this.handleClose}
					aria-labelledby="child-modal-title"
					aria-describedby="child-modal-description"
				>
					<Box sx={style}>
						<Typography id="modal-modal-title" variant="h6" component="h2">
							{this.state.message}
						</Typography>
						<Typography id="modal-modal-description" sx={{ mt: 2 }}>
							<ButtonGroup>
								<Button variant="outlined" onClick={this.closeDeleteButton}>
									Ok
								</Button>
							</ButtonGroup>
						</Typography>
					</Box>
				</Modal>

				<Modal
					sx={{ background: '#000000ad' }}
					hideBackdrop
					open={this.state.testwebhook}
					onClose={this.handleClose}
					aria-labelledby="child-modal-title"
					aria-describedby="child-modal-description"
				>
					<Box sx={style}>
						<div style={{ marginBottom: 20 }}>
							<Typography id="modal-modal-title" variant="h6" component="h2" style={{ marginBottom: 20 }}>
								{'VERIFY THE WEBHOOK URL'}
							</Typography>

							{this.state.error && (
								<Alert severity="error" sx={{ textAlign: 'left' }}>
									{this.state.error.trim()}
									<br />
									{'Look at the '}

									<NavLink to="/developers/documentation">documentation</NavLink>
									{'.'}
								</Alert>
							)}
							{this.state.success && <Alert severity="success">{this.state.success}</Alert>}
							{/* <Button
								variant="outlined"
								sx={{
									color: 'black',
									':hover': {
										backgroundColor: '#119e32',
										color: 'white',
									},
								}}
								onClick={() => {
									this.checkWebhook(this.state.webhook_last);
								}}
							>
								{'TEST WEBHOOK URL'}
							</Button> */}
						</div>
						<Typography id="modal-modal-description" sx={{ mt: 2 }}>
							<ButtonGroup>
								<Button
									variant="outlined"
									onClick={() => {
										this.setState({ testwebhook: false });
									}}
								>
									{'Cancel'}
								</Button>
								<Button
									disabled={!this.state.testwebhookresult}
									variant="outlined"
									onClick={() => {
										this.handleSubmit({ default: false, ...initials, webhook_new: this.state.webhook_last });
									}}
								>
									{this.state.saved}
								</Button>
							</ButtonGroup>
						</Typography>
					</Box>
				</Modal>
			</Page>
		);
	}
}

export default connect((state) => ({ user: state.access.user.loggedUserObj, product: state.product.maytapi }))(Webhook);
